import { STOCK_SURVILLANCE, STOCK_SURVILLANCE_CLEAR_MSG, STOCK_SURVILLANCE_ERROR, STOCK_SURVILLANCE_HIDE_ERROR, STOCK_SURVILLANCE_MSG, STOCK_SURVILLANCE_START_LOADER, STOCK_SURVILLANCE_STOP_LOADER, } from "../interface/iStockSurvillance";
const initialState = {
    data: {
        asm: {
            longTerm: {
                asOnDate: "",
                stkList: [],
            },
            shortTerm: {
                asOnDate: "",
                stkList: [],
            },
        },
        gsm: {
            asOnDate: "",
            stkList: [],
        },
        fnoBanList: {
            asOnDate: "",
            securities: [],
            possibleEntrance: [],
            possibleExits: [],
        },
    },
    asmMessage: {
        msg: null,
        show: false,
        icon: null,
    },
    gsmMessage: {
        msg: "",
        show: false,
        icon: "",
    },
    fnoBanMessage: {
        msg: "",
        show: false,
        icon: "",
    },
    stockSurveillanceLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const stockSurveillanceReducer = (state = initialState, action) => {
    switch (action.type) {
        case STOCK_SURVILLANCE:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case STOCK_SURVILLANCE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case STOCK_SURVILLANCE_MSG:
            return Object.assign(Object.assign({}, state), { [action.errorMsg]: action.payload.message });
        case STOCK_SURVILLANCE_CLEAR_MSG:
            return Object.assign(Object.assign({}, state), { [action.errorMsg]: initialState[action.errorMsg] });
        case STOCK_SURVILLANCE_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case STOCK_SURVILLANCE_START_LOADER:
            return Object.assign(Object.assign({}, state), { stockSurveillanceLoader: true });
        case STOCK_SURVILLANCE_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { stockSurveillanceLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default stockSurveillanceReducer;
